import * as yup from 'yup';

export const validationFields = {
  displayName: yup.string().required('Name is required'),
};

export const validationSchema = yup.object().shape({ ...validationFields });
